import { green, red } from "@mui/material/colors";

import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";

function createData(title: string, freeValue: string, plusValue: string, premiumValue: string) {
  return { title, freeValue, plusValue, premiumValue };
}

const rows = [
  createData("Rank and manage stakeholders", "y", "y", "y"),

  createData("Power interest grid", "y", "y", "y"),

  createData("Salience model", "y", "y", "y"),

  createData("Action plan", "y", "y", "y"),

  createData("Import stakeholders", "y", "y", "y"),

  createData("Export models to PDF", "y", "y", "y"),

  createData("Storage", "Local", "Cloud", "Cloud",),

  createData("Share projects with anyone", "n", "y", "y"),

  createData("Ad-free", "n", "n", "y")
];

const value = (v: string) => {
  switch (v) {
    case "n":
      return <ClearIcon style={{ color: red[500] }} />;
    case "y":
      return <CheckIcon style={{ color: green[500] }} />;
    default:
      return v;
  }
};

export { rows, value };
